import { ISubscriber, IEventAggregationService } from '@studyportals/event-aggregation-service-interface';
import { AnonymousStudentServiceReady, IAnonymousStudentService } from '@studyportals/anonymous-student-interfaces';
import { StudentField, IStudent } from '@studyportals/studentdomain';
import { WarningMessages } from '../enums/warning-messages';

export class StudentClient implements ISubscriber<AnonymousStudentServiceReady> {
	private client?: IAnonymousStudentService;

	constructor() {
		this.eventAggregationService?.subscribeTo(AnonymousStudentServiceReady.EventType, this, true);
	}

	private get eventAggregationService(): IEventAggregationService {
		return window['EventAggregationService'];
	}

	public notify(event: AnonymousStudentServiceReady): void {
		this.client = event.anonymousStudentService;
	}

	public async getData(fields: StudentField[]): Promise<IStudent | null> {
		if (!this.client) return null;

		try {
			return await this.client.getStudentData(fields);
		} catch {
			console.warn(WarningMessages.FAILED_TO_RETRIEVE_STUDENT_DATA);
			return null;
		}
	}

	public async saveStudentData(studentData: IStudent): Promise<void | null> {
		if (!this.client) return null;

		try {
			return await this.client.setStudentData(studentData);
		} catch {
			console.warn(WarningMessages.FAILED_TO_SET_STUDENT_DATA);
			return null;
		}
	}

	public async getCompleteness(fields: StudentField[]): Promise<number> {
		if (!this.client) return 0;

		try {
			return await this.client.getStudentDataCompleteness(fields);
		} catch {
			console.warn(WarningMessages.FAILED_TO_RETRIEVE_PROFILE_COMPLETENESS);
			return 0;
		}
	}
}
